import { ActivitiesSingleProperties } from 'apps/web/enums/pageKey';
import { getLocalStorageItem } from 'apps/web/utils/helper';

import { Language } from '@lessonPlanner/enums';

import ACTIVITIES_FORM_KEYS from './formKeys';

const formDefaultValues = () => ({
  local: {
    [ACTIVITIES_FORM_KEYS.subject]: getLocalStorageItem(
      ActivitiesSingleProperties.subject,
    ),
    [ACTIVITIES_FORM_KEYS.gradeLevel]: getLocalStorageItem(
      ActivitiesSingleProperties.gradeLevel,
    ),
    [ACTIVITIES_FORM_KEYS.objective]: getLocalStorageItem(
      ActivitiesSingleProperties.objective,
    ),
    [ACTIVITIES_FORM_KEYS.difficulty]: getLocalStorageItem(
      ActivitiesSingleProperties.difficulty,
    ),
    [ACTIVITIES_FORM_KEYS.materials]: getLocalStorageItem(
      ActivitiesSingleProperties.materials,
    ),
    [ACTIVITIES_FORM_KEYS.time]: getLocalStorageItem(
      ActivitiesSingleProperties.time,
    ),
    [ACTIVITIES_FORM_KEYS.language]: getLocalStorageItem(
      ActivitiesSingleProperties.language,
      Language.ENGLISH,
    ),
  },
  american: {
    [ACTIVITIES_FORM_KEYS.curriculumFramework]: getLocalStorageItem(
      ActivitiesSingleProperties.curriculumFramework,
    ),
    [ACTIVITIES_FORM_KEYS.gradeLevel]: getLocalStorageItem(
      ActivitiesSingleProperties.gradeLevel,
    ),
    [ACTIVITIES_FORM_KEYS.subject]: getLocalStorageItem(
      ActivitiesSingleProperties.subject,
    ),
    [ACTIVITIES_FORM_KEYS.specificStandards]: getLocalStorageItem(
      ActivitiesSingleProperties.specificStandards,
    ),
    [ACTIVITIES_FORM_KEYS.objective]: getLocalStorageItem(
      ActivitiesSingleProperties.objective,
    ),
    [ACTIVITIES_FORM_KEYS.strategies]: getLocalStorageItem(
      ActivitiesSingleProperties.strategies,
    ),
    [ACTIVITIES_FORM_KEYS.difficulty]: getLocalStorageItem(
      ActivitiesSingleProperties.difficulty,
    ),
    [ACTIVITIES_FORM_KEYS.materials]: getLocalStorageItem(
      ActivitiesSingleProperties.materials,
    ),
    [ACTIVITIES_FORM_KEYS.time]: getLocalStorageItem(
      ActivitiesSingleProperties.time,
    ),
  },
});

export default formDefaultValues;
